import { layoutMaths } from "../lib/maths";

/**
 * Typed text, drawn the way it would be written.
 *
 * "3/8" becomes a stacked fraction, "x^2" a superscript, "sqrt(2)" a root
 * sign. The text itself is never changed - this only draws it - because the
 * text is what is stored, what is compared against the mark scheme and what
 * a child reads back over the phone. A preview that quietly restructured the
 * answer would be worse than none: they would stop believing the box.
 *
 * Nothing it does not recognise is a problem; that part is shown as typed.
 */
export default function MathsPreview({ value, className = "" }) {
  const parts = layoutMaths(value);
  if (parts.length === 0) return null;

  return (
    <span className={`inline-flex items-center gap-[1px] align-middle ${className}`}>
      {parts.map((p, i) => {
        if (p.type === "frac") {
          return (
            <span key={i} className="inline-flex flex-col items-center align-middle mx-[2px] leading-none">
              <span className="px-1 pb-[1px]">{p.top}</span>
              <span className="w-full border-t border-current" />
              <span className="px-1 pt-[1px]">{p.bottom}</span>
            </span>
          );
        }
        if (p.type === "sup") {
          return (
            <span key={i}>
              {p.base}
              <sup className="text-[0.7em] -top-[0.4em] relative">{p.exp}</sup>
            </span>
          );
        }
        if (p.type === "root") {
          return (
            <span key={i} className="inline-flex items-start">
              <span className="text-[1.1em] leading-none">&radic;</span>
              <span className="border-t border-current pt-[1px] px-[2px]">{p.value}</span>
            </span>
          );
        }
        return <span key={i} className="whitespace-pre">{p.value}</span>;
      })}
    </span>
  );
}
